import { Permission } from '@/lib/permissions/v1'
import { Route } from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'name',
        direction: 'asc',
    })
}
export enum CompanyContactRouteName {
    Index = 'company.contacts.index',
    Create = 'company.contacts.create',
    Edit = 'company.contacts.edit',
    Logs = 'company.contacts.logs',
    LogDetails = 'company.contacts.log.details',
    ResetPassword = 'company.contacts.reset-password',
    Show = 'company.contacts.show',
}

export default {
    path: 'contacts',
    name: CompanyContactRouteName.Index,
    component: () => import('@/views/company/contact/Index.vue'),
    meta: {
        label: 'Contacts',
        auth: true,
        permission: Permission.CompanyContactViewAny,
    },
    children: [
        {
            path: 'create',
            name: CompanyContactRouteName.Create,
            component: () => import('@/views/company/contact/Index.vue'),
            meta: {
                label: 'Create Contact',
                auth: true,
                permission: Permission.CompanyContactCreate,
            },
        },
        {
            path: ':contactUuid/edit',
            name: CompanyContactRouteName.Edit,
            component: () => import('@/views/company/contact/Index.vue'),
            meta: {
                label: 'Edit Contact',
                auth: true,
                permission: Permission.CompanyContactUpdate,
            },
        },
        {
            path: ':contactUuid/reset-password',
            name: CompanyContactRouteName.ResetPassword,
            component: () => import('@/views/company/contact/Index.vue'),
            meta: {
                label: 'Reset Contact Password',
                auth: true,
                permission: Permission.CompanyContactUpdate,
            },
        },
        {
            path: ':contactUuid/details',
            name: CompanyContactRouteName.Show,
            component: () => import('@/views/company/contact/Index.vue'),
            meta: {
                label: 'Contact Details',
                auth: true,
                permission: Permission.CompanyContactView,
            },
        },
        {
            path: ':contactUuid/logs',
            name: CompanyContactRouteName.Logs,
            component: () => import('@/views/company/contact/Index.vue'),
            meta: {
                label: 'Contact Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: ':logId',
                    name: CompanyContactRouteName.LogDetails,
                    component: () => import('@/views/company/contact/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
    ],
}
